<template>
  <v-container fluid>
    <v-data-table
      :headers="dessertHeaders"
      :items="agents"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      :search="search"
      item-key="id_guide"
      show-expand
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Guide Data</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            solo
            dense
            append-icon="mdi-magnify"
            label="Search Guide Data"
            class="mr-3 white"
            outlined
            hide-details
          ></v-text-field>
          <v-dialog
            v-model="dialog"
            persistent
            width="800"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="primary"
                v-bind="attrs"
                v-on="on"
              >
                Add New Guide  <v-icon>{{ icons.mdiPlus }}</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="">
                <span class="text-h6 ">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col md="6">
                    <v-text-field
                      v-model="form.guide_name"
                      dense
                      outlined
                      placeholder="Guide Name"
                      label="Guide Name"
                    />
                    <v-select
                      v-model="form.have_licence"
                      :items="['YES','NO']"
                      dense
                      outlined
                      placeholder="Have Licence"
                      label="Have Licence"
                    />
                    <v-text-field
                      v-model="form.phone"
                      dense
                      outlined
                      placeholder="Phone"
                      label="Phone"
                    />

                    <v-currency-field
                      v-model="form.rate"
                      prefix="Rp."
                      dense
                      outlined
                      placeholder="Rate"
                      label="Rate"
                    />
                    <v-textarea
                      v-model="form.address"
                      label="Address"
                      placeholder="Address"
                      outlined
                      dense
                    ></v-textarea>
                  </v-col>

                  <v-col>
                    <v-text-field
                      v-model="form.languange"
                      dense
                      outlined
                      placeholder="Languange"
                      label="Language"
                    />
                    <v-select
                      v-model="form.status"
                      :items="[ACTIVE,PERMANENT,FREELANCE]"
                      dense
                      outlined
                      placeholder="Status"
                      label="Status"
                    />

                    <v-textarea
                      v-model="form.note"
                      label="Note"
                      placeholder="Note"
                      outlined
                      dense
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  class="text-capitalize"
                  text
                  @click="CekDialog()"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  class="text-capitalize"
                  text
                  @click="Save"
                >
                  {{ TittleButton }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-row>
            <v-col>
              <v-simple-table>
                <tbody>
                  <tr>
                    <td>Notes</td>
                    <td>: {{ item.note }}</td>
                  </tr>
                  <tr>
                    <td> Address</td>
                    <td>: {{ item.address }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </td>
      </template>
      <template #[`item.rate`]="{ item }">
        Rp. {{ Number(item.rate).toLocaleString() }}
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn
          small
          class="mr-2 text-capitalize primary"
          @click="editItem(item)"
        >
          <v-icon>{{ icons.mdiPencil }}</v-icon>
        </v-btn>
        <v-btn
          small
          class="mr-2 text-capitalize primary"
          @click="deleteItem(item)"
        >
          <v-icon>{{ icons.mdiTrashCan }}</v-icon>
        </v-btn>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Reset
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import axios from 'axios'
import {
  mdiPencil,
  mdiTrashCan,
  mdiPlus,
  mdiClose,
  mdiCalendar,
} from '@mdi/js'

export default {

  data() {
    return {
      icons: {
        mdiPencil,
        mdiTrashCan,
        mdiPlus,
        mdiClose,
        mdiCalendar,
      },
      modal: false,
      modal5: false,
      expanded: [],
      singleExpand: true,
      dialog: false,
      editedIndex: -1,
      search: '',
      form: {
        guide_name: '',
        have_licence: '',
        id_guide: '',
        phone: '',
        address: '',
        rate: '',
        languange: '',
        status: '',
        note: '',
      },
      service: [],
      dessertHeaders: [
        { text: 'Guide Name', value: 'guide_name' },

        { text: 'Licence', value: 'have_licence' },
        { text: 'Phone', value: 'phone' },
        { text: 'Rate', value: 'rate' },
        { text: 'Languange', value: 'languange' },
        { text: 'status', value: 'status' },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          width: 200,
        },
      ],

      agents: [],

    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Add New Guide' : 'Edit Guide'
    },
    TittleButton() {
      return this.editedIndex === -1 ? 'Save Guide' : 'Update Guide'
    },
  },

  mounted() {
    this.initialize()
  },
  methods: {
    CekDialog() {
      this.form = {
        guide_name: '',
        have_licence: '',
        id_guide: '',
        phone: '',
        address: '',
        rate: '',
        languange: '',
        status: '',
        note: '',
      }
      this.dialog = false
    },
    editItem(item) {
      this.editedIndex = this.agents.indexOf(item)
      this.form = item
      this.dialog = true
    },
    deleteItem(item) {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/DeleteGuide', item).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    initialize() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.get('auth/Guide').then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.agents = response.data.data
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    Save() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/SaveGuide', this.form).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
        this.dialog = false
        this.CekDialog()
        this.editedIndex = -1
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
  },
}
</script>
